import en from "commonAssets/i18n/en";

// WP-1490: the Credit Benefit Request portal reuses the claim submission flow,
// whose confirmation modal, banner, and confirmation-page copy are
// claim-oriented. Override those strings for the credit-benefit flow. The
// confirmation-page layout itself is overridden in creditBenefitRequest.mjs.
const enWithOverrides = {
    ...en,
    // The OTP gate protects the Credit Benefit Access portal, not a claim form.
    otp_instructions_2:
        "Please enter the 6 digit code below to access your form.",
    confirmation_this_is_a_copy: "THIS IS A COPY OF YOUR ACCESS FORM",
    confirmation_screen_additional: {
        ...en.confirmation_screen_additional,
        body: "<p>Your Credit Benefit Access Form has been submitted. Your Credit Benefit redemption code will be emailed to you within 7 business days. If you don't receive your redemption code after 7 business days, please check your spam filter.</p>",
    },
    confirmation_page: {
        ...en.confirmation_page,
        title: "Your Credit Benefit Access Form has been submitted successfully.",
        claim_details: {
            ...en.confirmation_page.claim_details,
            title: "Your Submission Details",
            body: "FORM INFORMATION",
            footer: "If you have any questions regarding your request, please provide the Access ID listed above when contacting the Settlement Administrator.",
        },
    },
};

export default { en: enWithOverrides };
